import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="w-full bg-cobalt/10 px-5 py-12 sm:py-20" data-id="element-91" data-mp="223eltma3nb3z">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center rounded-2xl border border-cobalt/40 bg-white/70 p-8 text-center sm:p-12" data-id="element-92" data-mp="222n2b9ts13u2">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-cobalt/15 text-cobalt-deep" data-id="element-93" data-mp="1j4k8mhqaaipx">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-94" data-mp="1ee3qikbiq8x8" />
        </span>
        <h2 className="mt-5 font-serif-display text-2xl font-bold text-ink sm:text-3xl" data-id="element-95" data-mp="qo9j4i9yxckd">
          30-Day Money-Back Guarantee
        </h2>
        <p className="mt-2 text-sm font-medium text-cobalt-deep sm:text-base" data-id="element-96" data-mp="lo512ntew9s1">
          Your investment is fully protected
        </p>
        <div className="mt-6 space-y-4 text-sm leading-relaxed text-ink/75 sm:text-base" data-id="element-97" data-mp="oxfac9teapsk">
          <p data-id="element-98" data-mp="twrwstgctuum">
            Download the complete system. Print the workbooks. Use them with your students. See what
            happens.
          </p>
          <p data-id="element-99" data-mp="12rg0wga716hu">
            If within 30 days it&rsquo;s not everything you expected — email us and we&rsquo;ll
            refund every cent. No questions. No complicated process.
          </p>
          <p className="font-semibold italic text-ink" data-id="element-100" data-mp="azgvl3b5wrcj">Zero risk. Complete confidence.</p>
        </div>
        <div className="mt-8 w-full max-w-md" data-id="element-101" data-mp="f0u4xndgrco7">
          <CTAButton label="YES — I WANT THE COMPLETE SYSTEM" data-id="element-102" data-mp="f00twa7h2109" />
          <p className="mt-3 text-xs text-ink/60 sm:text-sm" data-id="element-103" data-mp="k0ou9mhlbu75">
            30-day money-back guarantee included
          </p>
        </div>
      </motion.div>
    </section>;
}